/* istanbul ignore file */

import { USER_ROLES } from '../auth/index';
import { LAYOUT_VALUES } from './enums';

const {
	CSM,
	IMPLEMENTATION,
	OWNER,
	LANGOPS,
	ADMIN,
	AGENT_ADMIN,
	AGENT,
	CONTENT_SUBMITTER,
	CONTENT_SUBMITTER_RESTRICTED,
	LANGOS_APP,
	OPS,
} = USER_ROLES;

// Default permissions
const PERMISSIONS = [OWNER, LANGOPS, ADMIN];

// Internal access only
const INTERNAL = [CSM, IMPLEMENTATION];

// Unbabel access only
const UNBABEL = [...INTERNAL, LANGOS_APP, OPS];

export const ROUTES = {
	OVERVIEW: {
		ACTIVE: true,
		NAME: 'manage-overview',
		LABEL: 'Home',
		ICON: 'interface-home',
		PATH: '/',
		PERMISSIONS: [...PERMISSIONS, ...UNBABEL],
	},
	PROJECTS: {
		ACTIVE: true,
		NAME: 'manage-web-order',
		LABEL: 'Projects',
		ICON: 'folder-empty',
		PATH: '/projects/:section',
		CHILDREN: [
			'PROJECTS_LIST',
			'PROJECTS_CREATE',
			'PROJECT_CREATION_INTRO',
			'PROJECT_CREATION_FINISH',
			'PROJECTS_DETAIL',
		],
		DISPLAY_CHILDREN: false,
		PERMISSIONS: [...UNBABEL, ...PERMISSIONS, CONTENT_SUBMITTER, CONTENT_SUBMITTER_RESTRICTED],
	},
	PROJECTS_LIST: {
		ACTIVE: true,
		NAME: 'projects-list',
		LABEL: 'Projects List',
		PARAMS: {
			section: 'all',
		},
		PERMISSIONS: [...UNBABEL, ...PERMISSIONS, CONTENT_SUBMITTER, CONTENT_SUBMITTER_RESTRICTED],
	},
	PROJECT_CREATION_INTRO: {
		ACTIVE: true,
		NAME: 'create-intro',
		LABEL: 'Create Project Intro',
		LAYOUT: LAYOUT_VALUES.FULLSCREEN,
		PARAMS: {
			section: 'create-intro',
		},
		PERMISSIONS: [...UNBABEL, ...PERMISSIONS, CONTENT_SUBMITTER, CONTENT_SUBMITTER_RESTRICTED],
	},
	PROJECT_CREATION_FINISH: {
		ACTIVE: true,
		NAME: 'create-finish',
		LABEL: 'Create Project Finish',
		LAYOUT: LAYOUT_VALUES.FULLSCREEN,
		PARAMS: {
			section: 'create-finish',
		},
		PERMISSIONS: [...UNBABEL, ...PERMISSIONS, CONTENT_SUBMITTER, CONTENT_SUBMITTER_RESTRICTED],
	},
	PROJECTS_CREATE: {
		ACTIVE: true,
		NAME: 'projects-create',
		LABEL: 'Create Project',
		LAYOUT: LAYOUT_VALUES.FULLSCREEN,
		PARAMS: {
			section: 'create-draft',
		},
		PERMISSIONS: [...UNBABEL, ...PERMISSIONS, CONTENT_SUBMITTER, CONTENT_SUBMITTER_RESTRICTED],
	},
	PROJECTS_DETAIL: {
		ACTIVE: true,
		NAME: 'projects-detail',
		LABEL: 'Project Detail',
		PARAMS: {
			section: ':projectId',
		},
		PERMISSIONS: [...UNBABEL, ...PERMISSIONS, CONTENT_SUBMITTER, CONTENT_SUBMITTER_RESTRICTED],
	},
	PIPELINES: {
		ACTIVE: true,
		NAME: 'manage-pipelines',
		LABEL: 'Translation Flows',
		ICON: 'unbabel-pipeline',
		PATH: '/pipeline-groups/',
		PERMISSIONS: [...UNBABEL, ...PERMISSIONS],
	},
	USERS: {
		ACTIVE: true,
		NAME: 'manage-users',
		LABEL: 'User Management',
		ICON: 'multiple-actions-address',
		PATH: '/users/:section',
		CHILDREN: ['USERS_ALL', 'USERS_NEW', 'USER_PROFILE_EDIT', 'USER_REVIEWER_PROFILE'],
		PERMISSIONS: [...PERMISSIONS, ...UNBABEL],
		DISPLAY_CHILDREN: false,
	},
	USERS_ALL: {
		ACTIVE: true,
		NAME: 'manage-users-all',
		LABEL: 'Users',
		PARAMS: {
			section: 'all',
		},
		PERMISSIONS: [...PERMISSIONS, ...UNBABEL],
	},
	USERS_NEW: {
		ACTIVE: true,
		NAME: 'users-new',
		LABEL: 'New User',
		PARAMS: {
			section: 'new',
		},
		PERMISSIONS: [...PERMISSIONS, ...UNBABEL],
	},
	USER_PROFILE_EDIT: {
		ACTIVE: true,
		NAME: 'edit-user-profile',
		LABEL: 'Edit User',
		PARAMS: {
			section: 'profile',
		},
		PERMISSIONS: [...PERMISSIONS, ...UNBABEL],
	},
	USER_REVIEWER_PROFILE: {
		ACTIVE: true,
		NAME: 'edit-reviewer-profile',
		LABEL: 'Edit Reviewer',
		PARAMS: {
			section: 'cr-profile',
		},
		PERMISSIONS: [...PERMISSIONS, ...UNBABEL],
	},
	BILLING: {
		ACTIVE: true,
		NAME: 'manage-billing',
		LABEL: 'Billing',
		ICON: 'money-dollar-circle',
		PATH: '/billing',
		PERMISSIONS: [...UNBABEL, OWNER],
	},
	PROFILE: {
		ACTIVE: true,
		NAME: 'profile',
		LABEL: 'Profile',
		ICON: 'user-default',
		PATH: '/profile',
		PERMISSIONS: [...PERMISSIONS, ...UNBABEL, AGENT_ADMIN, AGENT],
	},
	PRICING: {
		ACTIVE: true,
		NAME: 'pricing',
		LABEL: 'Pricing',
		ICON: 'money-tag',
		PATH: '/pipeline-groups',
		PERMISSIONS: [...PERMISSIONS, ...UNBABEL],
	},
};
